import { ClerkProvider } from "@clerk/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./styles.css";

async function start() {
  const runtime = await fetch("/api/config").then((response) => response.ok ? response.json() as Promise<{ clerkPublishableKey: string }> : null).catch(() => null);
  const publishableKey = runtime?.clerkPublishableKey || import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
  const root = createRoot(document.getElementById("root")!);
  if (!publishableKey || publishableKey.includes("REPLACE_WITH")) {
    root.render(<div className="setup-screen"><div className="brand-mark">OL</div><h1>Officer to Leader</h1><p>Authentication is not configured. Add the Clerk publishable key to begin local development.</p></div>);
    return;
  }
  root.render(
    <StrictMode>
      <ClerkProvider publishableKey={publishableKey} signInUrl="/sign-in" signUpUrl="/accept-invitation" afterSignOutUrl="/sign-in">
        <BrowserRouter><App /></BrowserRouter>
      </ClerkProvider>
    </StrictMode>,
  );
}

void start();

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
  window.addEventListener("load", () => { void navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).then((registration) => registration.update()); });
}
